module.exports = __webpack_public_path__ + "static/img/click@2x.02b7f60c.png";